<div
  *ngIf="isOpen"
  class="notifications-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="notifications-modal-title"
>
  <div class="notifications-modal__backdrop" (click)="onClose()"></div>

  <div class="notifications-modal__sheet">
    <header class="notifications-modal__header">
      <h2
        id="notifications-modal-title"
        class="notifications-modal__title t-16-700-primary"
      >
        Notificaciones
      </h2>
      <button
        type="button"
        class="notifications-modal__close"
        aria-label="Cerrar"
        (click)="onClose()"
      >
        <img
          src="assets/icons/ic_close_circle.svg"
          width="24"
          height="24"
          alt=""
          aria-hidden="true"
        />
      </button>
    </header>

    <div class="notifications-modal__body">
      <section
        *ngFor="let group of groups; trackBy: trackByLabel"
        class="notifications-modal__group"
      >
        <h3 class="notifications-modal__group-label">{{ group.label }}</h3>

        <ul class="notifications-modal__list">
          <li
            *ngFor="let notification of group.notifications; trackBy: trackById"
            class="notifications-modal__item"
            (click)="onNotificationClick(notification)"
          >
            <div class="notifications-modal__content">
              <p class="notifications-modal__title-item t-12-600-dark-16">
                {{ notification.title }}
              </p>
              <p class="notifications-modal__message t-12-500-light-dark">
                {{ notification.message }}
              </p>
              <p
                *ngIf="notification.createAt"
                class="notifications-modal__time t-10-400-tab-inactive"
              >
                <ng-container *ngIf="shouldUseRelativeDate(notification); else absoluteDate">
                  {{ notification.createAt | timeAgo }}
                </ng-container>
                <ng-template #absoluteDate>
                  {{ formatDate(notification) }}
                </ng-template>
              </p>
            </div>
            <span
              *ngIf="!notification.isRead"
              class="notifications-modal__status"
              aria-label="Nueva"
            ></span>
          </li>
        </ul>
      </section>

      <p
        *ngIf="!groups.length"
        class="notifications-modal__empty t-12-500-light-dark"
      >
        No tienes notificaciones por ahora.
      </p>
    </div>
  </div>
</div>
